export default '/build/9f7a1497.svg'